import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/navbar.css";

const Navbar = () => {
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const downloadsRef = useRef();
  const productsRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (downloadsRef.current && !downloadsRef.current.contains(event.target)) &&
        (productsRef.current && !productsRef.current.contains(event.target))
      ) {
        setIsDropdownOpen(false);
        setIsProductsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img src="logo1.png" alt="Mediasha Services" />
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {/* Static links */}
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/" ? "active-link" : ""
                }`}
                to="/"
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/about" ? "active-link" : ""
                }`}
                to="/about"
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/operation-theatre" ? "active-link" : ""
                }`}
                to="/operation-theatre"
              >
                OT Products
              </Link>
            </li>

            {/* Products with dropdown */}
            <li
  className="nav-item dropdown d-flex align-items-center position-relative"
  ref={productsRef}
  onMouseEnter={() => setIsProductsOpen(true)}
  onMouseLeave={() => setIsProductsOpen(false)}
>
  <Link
    to="/products"
    className={`nav-link ${location.pathname === "/products" ? "active-link" : ""}`}
  >
    MGPS Products ▾
  </Link>

  {isProductsOpen && (
    <ul className="dropdown-menu show position-absolute">
      <li>
        <Link className="dropdown-item" to="/hospitalCubicalCurtains">
          Hospital Cubical Curtains
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/bedHeadPanel">
          Bed Head Panel
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/gas-terminal">
          Gas Terminal
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/suction-devices">
          Suction Devices
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/oxygen-flow-meter">
          Oxygen Flow Meter
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/zonal-accessories">
          Zonal Accessories
        </Link>
      </li>
      
    </ul>
  )}
</li>
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  location.pathname === "/contact-us" ? "active-link" : ""
                }`}
                to="/contact-us"
              >
                Contact Us
              </Link>
            </li>

            {/* Downloads dropdown */}
            <li className="nav-item dropdown" ref={downloadsRef}>
              <button
                className="nav-link dropdown-toggle-btn"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                Downloads ▾
              </button>
              {isDropdownOpen && (
                <ul className="dropdown-menu show">
                  <li>
                    <a
                      className="dropdown-item"
                      href="/catalog Mediasha .pdf"
                      download
                    >
                      Catalog PDF
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="/finel.pdf"
                      download
                    >
                      Operation Theatre
                    </a>
                  </li>
                </ul>
                
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
